<!-- cart toggle -->
<button class="cart-toggle"
        mat-icon-button
        #cartPanelButton
        (click)="openShopCartMenueModal()">
    <mat-icon *ngIf="entrieCount <= 0" [svgIcon]="'shopping_cart'"></mat-icon>
    <mat-icon *ngIf="entrieCount > 0" [matBadge]="entrieCount" [svgIcon]="'shopping_cart'"></mat-icon>
</button>

